(function () {
  var root = document.querySelector('[data-attache-release]');
  if (!root) return;
  var params = new URLSearchParams(window.location.search);
  var keys = ['source', 'medium', 'campaign', 'content'];
  var defaults = ['direct', 'none', 'none', 'none'];
  var source = {}, stored = {};
  try { stored = JSON.parse(sessionStorage.getItem('attache_attribution') || '{}'); } catch (e) {}
  var explicit = keys.some(function (key) { return params.has('utm_' + key); });
  keys.forEach(function (key, i) {
    var value = explicit ? params.get('utm_' + key) : stored[key];
    source[key] = String(value || defaults[i]).toLowerCase().replace(/[^a-z0-9_-]/g, '_').slice(0, 64);
  });
  try { sessionStorage.setItem('attache_attribution', JSON.stringify(source)); } catch (e) {}
  var tags = root.querySelector('[data-attache-tags]');
  if (tags) tags.value = ['ATTACHE No. 1 Release List'].concat(keys.map(function (key) {
    return 'attache_' + key + '_' + source[key];
  })).join(',');
  function publish(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, attache: source });
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, source);
      }
    } catch (e) {}
  }
  publish('attache_private_release_view');
  var form = root.querySelector('[data-attache-signup]');
  if (form) form.addEventListener('submit', function () {
    try { sessionStorage.setItem('attache_signup_pending', String(Date.now())); } catch (e) {}
    publish('attache_private_release_submit');
  });
  if (root.querySelector('[data-attache-success]')) {
    try {
      var pending = Number(sessionStorage.getItem('attache_signup_pending'));
      sessionStorage.removeItem('attache_signup_pending');
      if (pending && Date.now() - pending < 1800000 && !sessionStorage.getItem('attache_signup_confirmed')) {
        publish('attache_private_release_signup');
        sessionStorage.setItem('attache_signup_confirmed', '1');
      }
    } catch (e) {}
  }
})();
